const noOp = () => {}

export default noOp
